import React from 'react';
import { Dropdown } from 'primereact/dropdown';

interface SelectOption {
  label: string;
  value: any;
}

interface SelectProps {
  id: string;
  label?: string;
  value: any;
  onChange: (value: any) => void;
  options: SelectOption[];
  placeholder?: string;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  filter?: boolean;
  filterPlaceholder?: string;
  showClear?: boolean;
}

const Select: React.FC<SelectProps> = ({
  id,
  label,
  value,
  onChange,
  options,
  placeholder,
  error,
  disabled = false,
  required = false,
  className = '',
  filter = false,
  filterPlaceholder = 'Search...',
  showClear = false,
}) => {
  const baseClasses = `w-full h-12 border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none transition-colors duration-200 ${className}`;
  const errorClasses = error ? 'p-invalid border-red-500' : '';
  const disabledClasses = disabled ? 'bg-gray-100 cursor-not-allowed' : '';

  return (
    <div className="space-y-3">
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-gray-700">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      
      <Dropdown
        id={id}
        value={value}
        options={options}
        onChange={(e) => onChange(e.value)}
        placeholder={placeholder}
        className={`${baseClasses} ${errorClasses} ${disabledClasses}`}
        disabled={disabled}
        filter={filter}
        filterPlaceholder={filterPlaceholder}
        showClear={showClear}
        optionLabel="label"
        optionValue="value"
      />
      
      {error && (
        <small className="p-error text-red-600 text-sm mt-1 block">{error}</small>
      )}
    </div>
  );
};

export default Select; 